import React, { useState } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Aqui seria implementada a lógica de envio do formulário para um backend
    console.log('Formulário enviado:', formData);
    setFormSubmitted(true);
    
    // Reset do formulário após envio
    setFormData({
      name: '',
      email: '',
      phone: '',
      service: '',
      message: '',
    });
    
    // Reset da mensagem de sucesso após 5 segundos
    setTimeout(() => {
      setFormSubmitted(false);
    }, 5000);
  };

  const { elementRef, isVisible } = useScrollAnimation({ triggerOnce: true });

  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* decor */}
      <div className="absolute -top-24 left-0 w-80 h-80 bg-secondary/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-24 right-0 w-96 h-96 bg-primary/10 rounded-full blur-3xl" />

      <div className="container-custom relative z-10">
        <div
          ref={elementRef as React.RefObject<HTMLDivElement>}
          className={`max-w-5xl mx-auto transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <div className="text-center mb-12">
            <h2 className="section-title">Entre em Contato</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Preencha o formulário abaixo para agendar uma consulta, tirar dúvidas ou solicitar mais informações sobre nossos tratamentos.
            </p>
          </div>

          {formSubmitted ? (
            <div className="bg-green-50 border border-green-200 text-green-700 p-4 rounded-xl mb-8 text-center shadow-sm">
              <p className="font-medium">Mensagem enviada com sucesso!</p>
              <p className="text-sm mt-1">Entraremos em contato em breve.</p>
            </div>
          ) : null}

          <form onSubmit={handleSubmit} className="backdrop-blur bg-white/80 border border-gray-100 p-8 md:p-10 rounded-2xl shadow-xl">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                  Nome Completo *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-200/70 rounded-xl bg-white/70 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent shadow-sm"
                  placeholder="Seu nome"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-200/70 rounded-xl bg-white/70 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent shadow-sm"
                  placeholder="seu.email@exemplo.com"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                  Telefone *
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-200/70 rounded-xl bg-white/70 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent shadow-sm"
                  placeholder="(00) 00000-0000"
                  required
                />
              </div>
              
              <div>
                <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-1">
                  Serviço de Interesse
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-200/70 rounded-xl bg-white/70 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent shadow-sm"
                >
                  <option value="">Selecione um serviço</option>
                  <option value="toxina-botulinica">Toxina botulínica</option>
                  <option value="preenchimento-facial">Preenchimento facial</option>
                  <option value="cirurgias-da-face">Cirurgias da face</option>
                  <option value="bioestimulador-colageno">Bioestimulador de colágeno</option>
                  <option value="tratamento-capilar">Tratamento capilar</option>
                  <option value="tratamento-corporal">Tratamento corporal</option>
                  <option value="vasinhos">Vasinhos</option>
                  <option value="tratamento-de-pele">Tratamento de pele</option>
                </select>
              </div>
              
              <div className="md:col-span-2">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  Mensagem *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={5}
                  className="w-full px-4 py-3 border border-gray-200/70 rounded-xl bg-white/70 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent shadow-sm"
                  placeholder="Como podemos ajudar?"
                  required
                ></textarea>
              </div>
            </div>
            
            <div className="mt-8 flex items-center justify-center">
              <button
                type="submit"
                className="w-full md:w-auto btn-primary px-8 py-3 rounded-xl shadow-lg hover:shadow-xl"
              >
                Enviar Mensagem
              </button>
            </div>
            
            <p className="text-xs text-gray-500 mt-4 text-center">
              * Campos obrigatórios. Ao enviar este formulário, você concorda com nossa política de privacidade.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;